import { useCallback } from 'react'
import { TooltipV2 } from 'builder/components/Tooltip'
import { ResumeFieldSuggest } from 'builder/modules/resumeEditor'
import useImproveResumePanel from '../ImproveResumePanel/hooks/useImproveResumePanel'
import { CompletionBadge } from '../DocumentEditor/TabsResumeScore/styles'

type Props = {
  suggestion: ResumeFieldSuggest
  score: number
}

export const SuggestionBadge = ({ suggestion, score }: Props) => {
  const { handleSuggestionClick } = useImproveResumePanel()

  const handleClick = useCallback(() => {
    handleSuggestionClick(suggestion)
  }, [suggestion, handleSuggestionClick])

  return (
    <TooltipV2 content={suggestion.text}>
      <CompletionBadge onClick={handleClick} $enableHover={true} $width={39}>
        +{score}%
      </CompletionBadge>
    </TooltipV2>
  )
}
